import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import process from '@/components/examine/process.vue';
import newProgress from '@/components/examine/newProgress.vue';
import { auditScheduleResource } from '@/views/examine/typeManage/request';
import { auditSchedule, auditDetail } from './request';
import sharedNode from './components/sharedNode.vue';
import currentNode from './components/currentNode.vue';
export default {
  components: {
    process,
    newProgress,
    sharedNode,
    currentNode
  },
  data() {
    return {
      scheduleList: [],
      procedureList: [],
      step: 0,
      scheduleInfo: {},
      detailsObj: null,
      echoNodeIsEdit: false,
      //回显区可编辑状态true可编辑false不可编辑
      editSharedNodeInfo: [] //回显区可以编辑的数据
    };
  },
  created() {
    this.getInfoFun();
  },
  methods: {
    goInfoFun(val) {
      this.scheduleInfo = val;
      this.stepFun();
      this.detailFun();
    },
    // 审核进度详情
    async detailFun() {
      this.detailsObj = null;
      const res = await auditDetail({
        auditScheduleId: this.scheduleInfo.id,
        flowMark: this.$route.params.flowMark
      });
      console.log(res, this.$route.params.type, '-------详情----------');
      /**
       * 操作按钮进入$route.params.type == 2可以编辑
       * 查看按钮进入$route.params.type == 1不可以编辑
       */
      if (this.$route.params.type == 2) {
        // 判断回显节点是否可编辑
        if (res.renderState === 'EDIT') {
          this.echoNodeIsEdit = true;
          res.sharedNodeInfo.forEach(item => {
            if (item.isEdit === true) {
              item.echoNodeIsEdit = true;
            } else {
              item.echoNodeIsEdit = false;
            }
          });
        } else {
          this.echoNodeIsEdit = false;
        }
      } else {
        console.log('-----不可以编辑------');
        this.echoNodeIsEdit = false;
      }
      this.detailsObj = res;
    },
    // 审核流程
    async getInfoFun() {
      console.log(this.$route.params, '-----------');
      const res = await auditScheduleResource({
        auditFlowTypeId: this.$route.params.auditFlowTypeId
      });
      if (res.length != 0) {
        this.procedureList = res;
      }
      this.getscheduleFun();
    },
    // 审核进度
    async getscheduleFun() {
      this.scheduleList = await auditSchedule({
        auditFlowDetailId: this.$route.params.id,
        flowMark: this.$route.params.flowMark
      });
      this.scheduleInfo = this.scheduleList[this.scheduleList.length - 1];
      console.log(this.scheduleInfo, 'this.scheduleInfo');
      if (!this.scheduleInfo.currentScheduleOperator && !this.scheduleInfo.operationAt && this.scheduleInfo.step == '0') {
        this.scheduleInfo = this.scheduleList[this.scheduleList.length - 2];
      }
      this.stepFun();
      this.detailFun();
    },
    stepFun() {
      this.step = this.procedureList.findIndex(val => {
        return val.id == this.scheduleInfo.auditFlowScheduleId;
      });
      if (this.step == -1) {
        this.step = 0;
      }
    }
  }
};